// ManufacturingIndustrialSwitchesAndRoutersSubcategoryPage.js

import React, { useState, useEffect  } from "react";
import { useLocation } from "react-router-dom";
import ShareButton from "../../../Common Components/ShareButton";
import { Helmet } from "react-helmet";
// import favicon from "../public/favicon.ico";
// import manifest from "../public/manifest.json";
import "./ManufacturingIndustrialSwitchesAndRoutersSubcategoryPage.css";
import ManufacturingCategoryPageNavBar from "../ManufacturingCategoryPageNavBar";
import ManufacturingProductComponent from "../../ManufacturingComponents/ManufacturingProductComponent";
import ManufacturingHeader from "../../ManufacturingComponents/ManufacturingHeader";
import ManufacturingFooter from "../../ManufacturingComponents/ManufacturingFooter";
import RUT300 from "../../../assets/pdf/RUT-300.pdf";
import RUT956 from "../../../assets/pdf/RUT-956.pdf";
import RUTX50 from "../../../assets/pdf/RUTX50.pdf";
import TRB245 from "../../../assets/pdf/TRB245.pdf";
import TRB255 from "../../../assets/pdf/TRB255.pdf";
import TSW202 from "../../../assets/pdf/TSW202.pdf";
import TSW212 from "../../../assets/pdf/TSW212.pdf";
import EDS510A from "../../../assets/pdf/EDS-510A.pdf";
import EDS528E from "../../../assets/pdf/EDS-528E.pdf";
import MDSG4028 from "../../../assets/pdf/MDS-G4028-4XGS.pdf";
import IKSG6824A from "../../../assets/pdf/IKS-G6824A.pdf";
import RKSG4028 from "../../../assets/pdf/RKS-G4028.pdf";
import G4302LTE4 from "../../../assets/pdf/G4302-LTE4.pdf";
import EKI7412G from "../../../assets/pdf/EKI-7412G-4XP.pdf";
import EKI7428G from "../../../assets/pdf/EKI-7428G-4CA.pdf";
import EKI7559MI from "../../../assets/pdf/EKI-7559MI.pdf";
import EKI7708G from "../../../assets/pdf/EKI-7708G-4F.pdf";
import EKI9728G from "../../../assets/pdf/EKI-9728G-4X8CI.pdf";
import EKI9226G from "../../../assets/pdf/EKI-9226G-20FMI.pdf";
import EKI9508E from "../../../assets/pdf/EKI-9508E-ML.pdf";
import ContactUsBot from "../../../Common Components/ContactUsBot";
import Whatsapp from "../../../Common Components/Whatsapp";
import SwitchtoEnterprise from "../../ManufacturingComponents/SwitchtoEnterprise";
import ContactButtons from "../../../Common Components/ContactButtons";
import CallMePopup from "../../../Common Components/CallMePopup";
import ShowMoreIcons from "../../../Common Components/ShowMoreIcons";

const ManufacturingIndustrialSwitchesAndRoutersSubcategoryPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSubproduct, setCurrentSubproduct] = useState(1);
  const productsPerPage = 4;

  // const subproductNames = {
  //   1: "Teltonika",
  //   2: "Moxa",
  //   3: "Advantech",
  // };

  const productDataList1 = [
    // RUT 300
    {
      id: "rut-300",
      images: [
        require("../../../assets/productImages/RUT-300-1.jpg"),
        require("../../../assets/productImages/RUT-300-2.jpg"),
        require("../../../assets/productImages/RUT-300-3.jpg"),
        require("../../../assets/productImages/RUT-300-4.jpg"),
      ],
      title: "Teltonika RUT 300",
      about: (
        <>
          <p>
            5 x Fast Ethernet ports (10/100 Mbps). 2 x Configurable digital Inputs/Outputs,For remote management,remote access to PLC with Numerous VPN services including OpenVPN, IPsec, PPTP, L2TP & DMVPN, L2TP, DMVPN, Stunnel and others.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika RUT 300 in Ajmer, Jharkhand, Vishakhapatnam,
            Kota, Surat, Kolhapur, Orissa, Hosur. Contact us to avail best
            prices and discount for Teltonika RUT 300.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>SSTP client instance support</li>
          <li>ZeroTier VPN client support</li>
        </>
      ),
      downloadLink: RUT300,
      hyperlinks: [],
    },

    //RUT 956
    {
      id: "rut-956",
      images: [
        require("../../../assets/productImages/RUT-956-1.jpg"),
        require("../../../assets/productImages/RUT-956-2.jpg"),
        require("../../../assets/productImages/RUT-956-3.jpg"),
        require("../../../assets/productImages/RUT-956-4.jpg"),
      ],
      title: "Teltonika RUT 956",
      about: (
        <>
          <p>

            Teltonika RUT 956-  4 x LAN/WAN ports, 10/100/ Mbps, compliance with IEEE 802.3, IEEE 802.3u, 802.3az standards, supports auto MDI/MDIX crossover,Dual SIM With auto failover, backup WAN and other switching scenarios, Remote access VPN router, supports all Dynamic Routing protocol such as Static routing, Dynamic routing (BGP, OSPF v2, RIP v1/v2, EIGRP, NHRP), Policy based routing,802.11b/g/n (Wi-Fi 4) with data transmission rates up to 300 Mbps, 802.11r fast transition,
            MULTIPLE INTERFACES
            Ethernet, Serial (RS232, RS485) and multiple Inputs/Outputs.

          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of  Teltonika RUT 956 in Ahmednagar, Taloja, Shedung, Rabale, Kolhapur, Bhavnagar, Surat, Ahmedabad, Rajkot, Anand, patratu, Jamshedpur, Bengaluru, Rourkela, Sambhalpur, Bhubeneshwar, Cuttak, Mumbai. Contact us to avail best
            prices and discount for Teltonika RUT 956.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>Band lock, Used band status display</li>
          <li>Balance Internet traffic over multiple WAN connections</li>
          <li>Possibility to mount remote file system via SSH protocol</li>
        </>
      ),
      downloadLink: RUT956,
      hyperlinks: [],
    },

    //RUTX50
    {
      id: "rutx50",
      images: [
        require("../../../assets/productImages/RUTX50-1.jpg"),
        require("../../../assets/productImages/RUTX50-2.jpg"),
        require("../../../assets/productImages/RUTX50-3.jpg"),
        require("../../../assets/productImages/RUTX50-4.jpg"),
      ],
      title: "Teltonika RUTX50",
      about: (
        <>
          <p>
            Teltonika RUTX50 - 5 x LAN/WAN ports, 10/100/1000 Mbps, compliance with IEEE 802.3, IEEE 802.3u, 802.3az standards, supports auto MDI/MDIX crossover,Dual SIM With auto failover, backup WAN and other switching scenarios, Remote access VPN router, supports all Dynamic ROuting protocol such as Static routing, Dynamic routing (BGP, OSPF v2, RIP v1/v2, EIGRP, NHRP), Policy based routing,802.11b/g/n/ac Wave 2 (Wi-Fi 5) with data transmission rates up to 867 Mbps (Dual Band, MU-MIMO), 802.11r fast transition
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika RUTX50 in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to avail best
            prices and discount for Teltonika RUTX50.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>
            Router assigns its mobile WAN IP address to another device on LAN
          </li>
          <li>View all your Firewall statistics, rules, and rule counters</li>
        </>
      ),
      downloadLink: RUTX50,
      hyperlinks: [],
    },

    //TRB245
    {
      id: "trb245",
      images: [
        require("../../../assets/productImages/TRB245-1.jpg"),
        require("../../../assets/productImages/TRB245-2.jpg"),
        require("../../../assets/productImages/TRB245-3.jpg"),
        require("../../../assets/productImages/TRB245-4.jpg"),
      ],
      title: "Teltonika TRB245",
      about: (
        <>
          <p>
            Teltonika TRB245 -1 x ETH port, 10/100 Mbps, Dual With auto failover, backup WAN and other switching scenarios,4G/LTE (Cat 4), 3G, 2G connectivity.RS232/RS485 serial communication interfaces support.Multiple Inputs and Outputs for remote monitoring and control.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika TRB245 in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to avail best
            prices and discount for Teltonika TRB245.
          </p>

        </>
      ),
      manufactiringFeature: (
        <>
          <li>SSTP client instance support</li>
          <li>ZeroTier VPN client support</li>
        </>
      ),
      downloadLink: TRB245,
      hyperlinks: [],
    },

    //TRB255:
    {
      id: "trb255",
      images: [
        require("../../../assets/productImages/TRB255-1.jpg"),
        require("../../../assets/productImages/TRB255-2.jpg"),
        require("../../../assets/productImages/TRB255-3.jpg"),
        require("../../../assets/productImages/TRB255-4.jpg"),
      ],
      title: "Teltonika TRB255",
      about: (
        <>
          <p>
            Teltonika TRB255 - 1 x ETH port, 10/100 Mbps, Dual With auto failover, backup WAN and other switching scenarios,4G/LTE (Cat M1), NB-IoT, 2G connectivity.RS232/RS485 serial communication interfaces support.Multiple Inputs and Outputs for remote monitoring and control.Static routing, Dynamic routing (BGP, OSPF v2, RIP v1/v2, EIGRP, NHRP), Policy based routing </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika TRB255 in Ajmer, Jharkhand, Vishakhapatnam,
            Kota, Surat, Kolhapur, Orissa, Hosur. Contact us to avail best
            prices and discount for Teltonika TRB255.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>
            STinc offers encryption, authentication and compression in it's
            tunnels.
          </li>
          <li>SSTP client instance support</li>
        </>
      ),
      downloadLink: TRB255,
      hyperlinks: [],
    },

    //TSW202:
    {
      id: "tsw202",
      images: [
        require("../../../assets/productImages/TSW202-1.jpg"),
        require("../../../assets/productImages/TSW202-2.jpg"),
        require("../../../assets/productImages/TSW202-3.jpg"),
        require("../../../assets/productImages/TSW202-4.jpg"),
      ],
      title: "Teltonika TSW202",
      about: (
        <>
          <p>
            Teltonika TSW202 - 8 x port PoE+ switch with 2 x SFP ports for fibre optic communication,
            L2 with additional L3 features for enhanced management and control,
            Supports PROFINET for automated data processing alongside other protocols,
            like EtherNet/IP and MRP
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika TSW202 in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to avail best
            prices and discount for Teltonika TSW202.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>MRP client role, MRP manager role</li>
          <li>Capability to restart PoE in a specific port</li>
        </>
      ),
      downloadLink: TSW202,
      hyperlinks: [],
    },

    //TSW212:
    {
      id: "tsw212",
      images: [
        require("../../../assets/productImages/TSW212-1.jpg"),
        require("../../../assets/productImages/TSW212-2.jpg"),
        require("../../../assets/productImages/TSW212-3.jpg"),
        require("../../../assets/productImages/TSW212-4.jpg"),
      ],
      title: "Teltonika TSW212",
      about: (
        <>
          <p>
            Teltonika TSW212 - 8 x Gigabit Ethernet ports switch with 2 x SFP ports for fibre optic communication,L2 with additional L3 features for enhanced management and control,Supports PROFINET for automated data processing alongside other protocols, like EtherNet/IP and MRP
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Teltonika TSW212 in Ahmednagar, Taloja, Shedung, Rabale, Kolhapur, Bhavnagar, Surat, Ahmedabad, Rajkot, Anand, patratu, Jamshedpur, Bengaluru, Rourkela, Sambhalpur, Bhubeneshwar, Cuttak, Mumbai. Contact us to avail best
            prices and discount for Teltonika TSW212.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>
            STinc offers encryption, authentication and compression in it's
            tunnels.
          </li>
          <li>Method of building scalable IPsec VPNs</li>
        </>
      ),
      downloadLink: TSW212,
      hyperlinks: [],
    },
  ];

  const productDataList2 = [
    //EDS-510A
    {
      id: "eds-510a",
      images: [
        require("../../../assets/productImages/EDS-510A-1.jpg"),
        require("../../../assets/productImages/EDS-510A-2.jpg"),
        require("../../../assets/productImages/EDS-510A-3.jpg"),
        require("../../../assets/productImages/EDS-510A-4.jpg"),
      ],
      title: "Moxa EDS-510A",
      about: (
        <>
          <p>
            The Moxa EDS-510A Gigabit managed redundant Ethernet switches are
            equipped with up to 3 Gigabit Ethernet ports, making them ideal for
            building a Gigabit Turbo Ring.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa EDS-510A in Pune, Aurangabad, Nasik, Ahmednagar, Taloja, Shedung, Rabale, Kolhapur,Vapi, Halol, Vadodara, Bhavnagar, Surat,Bhilwara, Solan,Sambhalpur, Hosur, Belgaum. Contact us to avail best
            prices and discount for Moxa EDS-510A.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>Port Trunking for optimum bandwidth utilization</li>
          <li>RMON for proactive and efficient network monitoring</li>
        </>
      ),
      downloadLink: EDS510A,
      hyperlinks: [],
    },

    //EDS-528E
    {
      id: "eds-528e",
      images: [
        require("../../../assets/productImages/EDS-528E-1.jpg"),
        require("../../../assets/productImages/EDS-528E-1.jpg"),
        require("../../../assets/productImages/EDS-528E-1.jpg"),
        require("../../../assets/productImages/EDS-528E-1.jpg"),
      ],
      title: "Moxa EDS-528E",
      about: (
        <>
          <p>
            The Moxa EDS-528E standalone, compact 28-port managed Ethernet switches
            have 4 combo Gigabit ports with built-in RJ45 or SFP slots for
            Gigabit fiber-optic communication.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa EDS-528E in Ajmer, Taloja, Bhubeneshwar,
            Kota, Surat, Kolhapur, Salem, Hyderabad. Contact us to avail best
            prices and discount for Moxa EDS-528E.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>IGMP snooping and GMRP for filtering multicast traffic</li>
          <li>SNMPv1/v2c/v3 for different levels of network management</li>
        </>
      ),
      downloadLink: EDS528E,
      hyperlinks: [],
    },

    //MDS-G4028-4XGS
    {
      id: "mds-g4028-4xgs",
      images: [
        require("../../../assets/productImages/MDS-G4028-4XGS-1.jpg"),
        require("../../../assets/productImages/MDS-G4028-4XGS-2.jpg"),
        require("../../../assets/productImages/MDS-G4028-4XGS-3.jpg"),
        require("../../../assets/productImages/MDS-G4028-4XGS-3.jpg"),
      ],
      title: "Moxa MDS-G4028-4XGS",
      about: (
        <>
          <p>
            The Moxa MDS-G4028-4XGS Series modular switches support 4 10GbE + 24
            Gigabit ports, including 4 embedded ports, 6 interface module
            expansion slots, and 2 power module slots.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa MDS-G4028-4XGS in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to
            avail best prices and discount for Moxa MDS-G4028-4XGS.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>
            Multiple interface type 4-port modules for greater versatility
          </li>
          <li>Passive backplane to minimize maintenance efforts</li>
        </>
      ),
      downloadLink: MDSG4028,
      hyperlinks: [],
    },

    //IKS-G6824A
    {
      id: "iks-g6824a",
      images: [
        require("../../../assets/productImages/IKS-G6824A-1.jpg"),
        require("../../../assets/productImages/IKS-G6824A-2.jpg"),
        require("../../../assets/productImages/IKS-G6824A-1.jpg"),
        require("../../../assets/productImages/IKS-G6824A-1.jpg"),
      ],
      title: "Moxa IKS-G6824A",
      about: (
        <>
          <p>
            Process automation and transportation automation applications
            combine data, voice, and video, and consequently require high
            performance and high reliability.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa IKS-G6824A in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to avail best
            prices and discount for Moxa IKS-G6824A.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>Layer 3 routing interconnects multiple LAN segments</li>
          <li>Up to 24 optical fiber connections(SFP slots)</li>
        </>
      ),
      downloadLink: IKSG6824A,
      hyperlinks: [],
    },

    //RKS-G4028
    {
      id: "rks-g4028",
      images: [
        require("../../../assets/productImages/RKS-G4028-1.jpg"),
        require("../../../assets/productImages/RKS-G4028-3.jpg"),
        require("../../../assets/productImages/RKS-G4028-4.jpg"),
        require("../../../assets/productImages/RKS-G4028-5.jpg"),
      ],
      title: "Moxa RKS-G4028",
      about: (
        <>
          <p>
            The RKS-G4028 Series is designed to meet the rigorous demands of
            mission-critical applications for industry and business, such as
            power substation automation systems, railway applications.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa RKS-G4028 in Ajmer, Taloja, Bhubeneshwar,
            Kota, Surat, Kolhapur, Salem, Hyderabad. Contact us to avail best
            prices and discount for Moxa  RKS-G4028.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>Modular interfaces for flexible connector type combinations</li>
          <li>Support for IEEE 802.3bt PoE for up to 90 W output per port</li>
        </>
      ),
      downloadLink: RKSG4028,
      hyperlinks: [],
    },

    //G4302-LTE4
    {
      id: "g4302-lte4",
      images: [
        require("../../../assets/productImages/G4302-LTE4-1.jpg"),
        require("../../../assets/productImages/G4302-LTE4-2.jpg"),
        require("../../../assets/productImages/G4302-LTE4-3.jpg"),
        require("../../../assets/productImages/G4302-LTE4-4.jpg"),
      ],
      title: "Moxa G4302-LTE4",
      about: (
        <>
          <p>
            The OnCell Moxa G4302-LTE4 Series is a reliable and powerful secure
            cellular router with global LTE coverage. This router provides
            reliable data transfers from serial and Ethernet to a cellular
            interface.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Moxa G4302-LTE4 in Ahmednagar, Taloja, Shedung, Rabale, Kolhapur, Bhavnagar, Surat, Ahmedabad, Rajkot, Anand, patratu, Jamshedpur, Bengaluru, Rourkela, Sambhalpur, Bhubeneshwar, Cuttak, Mumbai. Contact us to avail best
            prices and discount for Moxa G4302-LTE4.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>Power management support for wake-up time scheduling</li>
          <li>Cellular link redundancy with dual-SIM GuaranLink support</li>
        </>
      ),
      downloadLink: G4302LTE4,
      hyperlinks: [],
    },
  ];

  const productDataList3 = [
    //EKI-7412G-4XP
    {
      id: "eki-7412g-4xp",
      images: [
        require("../../../assets/productImages/EKI-7412G-4XP-1.jpg"),
        require("../../../assets/productImages/EKI-7412G-4XP-2.jpg"),
        require("../../../assets/productImages/EKI-7412G-4XP-3.jpg"),
        require("../../../assets/productImages/EKI-7412G-4XP-4.jpg"),
      ],
      title: " Advantech EKI-7412G-4XP",
      about: (
        <>
          <p>
            The  Advantech EKI-7412G-4XP is equipped with 8 Gigabit Ethernet ports plus 4
            10G SFP+ ports. It is ideal for large-scale networks like
            Surveillance Applications, that involve high-resolution videos and
            images.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-7412G-4XP in Pune, Aurangabad, Nasik, Ahmednagar, Taloja, Shedung, Rabale, Kolhapur,Vapi, Halol, Vadodara, Bhavnagar, Surat,Bhilwara, Solan,Sambhalpur, Hosur, Belgaum. Contact us to
            avail best prices and discount for Advantech EKI-7412G-4XP.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>8 Gigabit Ethernet Ports and 4 10G SFP Ports</li>
          <li>0 to 60°C operating temperature range</li>
        </>
      ),
      downloadLink: EKI7412G,
      hyperlinks: [],
    },

    //EKI-7428G-4CA
    {
      id: "eki-7428g-4ca",
      images: [
        require("../../../assets/productImages/EKI-7428G-4CA-1.jpg"),
        require("../../../assets/productImages/EKI-7428G-4CA-2.jpg"),
        require("../../../assets/productImages/EKI-7428G-4CA-3.jpg"),
        require("../../../assets/productImages/EKI-7428G-4CA-4.jpg"),
      ],
      title: "Advantech EKI-7428G-4CA",
      about: (
        <>
          <p>
            The Advantech EKI-7428G-4CA is an layer 2 full managed switch including 24
            Gigabit ports and 4 Gigabit combo ports. It is designed for
            rack-mount installation with 1U 19 design and suitable for edge to
            core networks.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-7428G-4CA in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore. Contact us to
            avail best prices and discount for Advantech EKI-7428G-4CA.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>24 x Gigabit ports + 4 x Gigabit Copper/SFP combo ports</li>
          <li>SFP socket for easy and flexible fiber expansion</li>
        </>
      ),
      downloadLink: EKI7428G,
      hyperlinks: [],
    },

    //EKI-7559MI
    {
      id: "eki-7559mi",
      images: [
        require("../../../assets/productImages/EKI-7559MI-1.jpg"),
        require("../../../assets/productImages/EKI-7559MI-2.jpg"),
        require("../../../assets/productImages/EKI-7559MI-3.jpg"),
        require("../../../assets/productImages/EKI-7559MI-4.jpg"),
      ],
      title: "Advantech EKI-7559MI",
      about: (
        <>
          <p>
            Both the Advantech EKI-7554SI/MI and EKI-7559SI/MI support two SC type Fiber
            ports, EKI-7554SI/MI four Fast Ethernet ports and EKI-7559SI/MI can
            support up to eight Fast Ethernet ports.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-7559MI in Vadodara, Bhavnagar,Mumbai, Surat, Ahmedabad, Rajkot,Gurugram, patratu, Jamshedpur,Coimbatoor, Hosur, Salem, Bengaluru, Belgaum, Manglore, Vapi, Halol, Nimrana. Contact us to avail best
            prices and discount for Advantech EKI-7559MI.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>2 x SC-type fiber ports, plus 8 Fast Ethernet ports</li>
          <li>Dual 12 ~ 48 VDC power input and 1 Relay Output</li>
        </>
      ),
      downloadLink: EKI7559MI,
      hyperlinks: [],
    },

    //EKI-7708G-4F
    {
      id: "eki-7708g-4f",
      images: [
        require("../../../assets/productImages/EKI-7708G-4F-1.jpg"),
        require("../../../assets/productImages/EKI-7708G-4F-2.jpg"),
        require("../../../assets/productImages/EKI-7708G-4F-3.jpg"),
        require("../../../assets/productImages/EKI-7708G-4F-4.jpg"),
      ],
      title: "Advantech EKI-7708G-4F",
      about: (
        <>
          <p>
            The Advantech EKI-7708G-4F and Advantech EKI-7708G-4FI provide users with abundant port
            options for connecting to various device types with 4 Gigabit ports
            and 4 SFP (mini-GBIC) ports.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-7708G-4F in Ahmednagar, Taloja, Shedung, Rabale, Kolhapur, Bhavnagar, Surat, Ahmedabad, Rajkot, Anand, patratu, Jamshedpur, Bengaluru, Rourkela, Sambhalpur, Bhubeneshwar, Cuttak, Mumbai. Contact us to avail best
            prices and discount for Advantech EKI-7708G-4F.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>4 Gigabit ports + 4 SFP ports</li>
          <li>SFP socket for Easy and Flexible Fiber Expansion</li>
        </>
      ),
      downloadLink: EKI7708G,
      hyperlinks: [],
    },

    //EKI-9728G-4X8CI
    {
      id: "eki-9728g-4x8ci",
      images: [
        require("../../../assets/productImages/EKI-9728G-4X8CI-1.jpg"),
        require("../../../assets/productImages/EKI-9728G-4X8CI-2.jpg"),
        require("../../../assets/productImages/EKI-9728G-4X8CI-3.jpg"),
        require("../../../assets/productImages/EKI-9728G-4X8CI-4.jpg"),
      ],
      title: "Advantech EKI-9728G-4X8CI",
      about: (
        <>
          <p>
            The Advantech EKI-9728G is an L3 management switch that supports RIP v1/v2,
            OSPF v1/v2/v3, and VRRP. Its wide operating temperature of -40 ~
            85°C means that it can operate reliably in harsh environments.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-9728G-4X8CI inAhmednagar, Taloja, Shedung, Rabale, Kolhapur, Bhavnagar, Surat, Ahmedabad, Rajkot, Anand, patratu, Jamshedpur, Bengaluru, Rourkela, Sambhalpur, Bhubeneshwar, Cuttak, Mumbai. Contact us to
            avail best prices and discount for Advantech EKI-9728G-4X8CI.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>L3 function : Static route , RIP v1/v2 , OSPF v2 , VRRP</li>
          <li>Security:802.1x HTTPS,SSH and SNMPv3</li>
        </>
      ),
      downloadLink: EKI9728G,
      hyperlinks: [],
    },

    //EKI-9226G-20FMI
    {
      id: "eki-9226g-20fmi",
      images: [
        require("../../../assets/productImages/EKI-9226G-20FMI-1.jpg"),
        require("../../../assets/productImages/EKI-9226G-20FMI-2.jpg"),
        require("../../../assets/productImages/EKI-9226G-20FMI-3.jpeg"),
        require("../../../assets/productImages/EKI-9226G-20FMI-1.jpg"),
      ],
      title: "Advantech EKI-9226G-20FMI",
      about: (
        <>
          <p>
            The Advantech EKI-9226G series are designed for power substation automation
            applications requiring IEC 61850-3 certification. Thanks to its -40
            ~ 85˚C wide operating temperature, it can operate well in harsh
            environments.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-9226G-20FMI in Pune, Aurangabad, Nasik, Ahmednagar, Taloja, Shedung, Rabale, Kolhapur,Vapi, Halol, Vadodara, Bhavnagar, Surat,Bhilwara, Solan,Sambhalpur, Hosur, Belgaum. Contact us to
            avail best prices and discount for Advantech EKI-9226G-20FMI.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>-40 ~ 85˚C wide-range operating temperature</li>
          <li>Dual Power input and 2 relay output</li>
        </>
      ),
      downloadLink: EKI9226G,
      hyperlinks: [],
    },

    //EKI-9508E-ML
    {
      id: "eki-9508e-ml",
      images: [
        require("../../../assets/productImages/EKI-9508E-ML-1.jpg"),
        require("../../../assets/productImages/EKI-9508E-ML-3.jpg"),
        require("../../../assets/productImages/EKI-9508E-ML-4.jpg"),
        require("../../../assets/productImages/EKI-9508E-ML-2.jpg"),
      ],
      title: "Advantech EKI-9508E-ML",
      about: (
        <>
          <p>
            Advantech EKI-9500 series switch is designed for railway application, with
            rugged and high EMC performance. EKI-9500 series is the suitable
            networking solution for rolling stock and wayside applications.
          </p>
          <br></br>
          <p>
            Calid Technologies is authorized partner, reseller, supplier, vendor
            and service provider of Advantech EKI-9508E-ML in Ajmer, Taloja, Bhubeneshwar,
            Kota, Surat, Kolhapur, Salem, Hyderabad. Contact us to avail best
            prices and discount for Advantech EKI-9508E-ML.
          </p>
        </>
      ),
      manufactiringFeature: (
        <>
          <li>8 x M12 D-coded 10/100Mbps ports</li>
          <li>Operating temperature range -40 ~ 70°C</li>
        </>
      ),
      downloadLink: EKI9508E,
      hyperlinks: [],
    },
  ];

  const getProductList = () => {
    switch (currentSubproduct) {
      case 1:
        return productDataList1;
      case 2:
        return productDataList2;
      case 3:
        return productDataList3;
      default:
        return [];
    }
  };

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = getProductList().slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const switchSubproduct = (subproductNumber) => {
    setCurrentSubproduct(subproductNumber);
    setCurrentPage(1);
    window.scrollTo(0, 0);
  };

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const productId = params.get("product");

    if (productId) {
      // Find which list contains this product
      const allLists = {
        1: productDataList1,
        2: productDataList2,
        3: productDataList3
      };

      for (let listKey in allLists) {
        const list = allLists[listKey];
        const foundIndex = list.findIndex((p) => p.id === productId);
        if (foundIndex !== -1) {
          setCurrentSubproduct(Number(listKey));

          // open page where this product exists
          const page = Math.floor(foundIndex / productsPerPage) + 1;
          setCurrentPage(page);

          setTimeout(() => {
            document.getElementById(productId)?.scrollIntoView({ behavior: "smooth" });
          }, 300);

          break;
        }
      }
    }
  }, [location.search]);

  return (
    <div className="industrialSwitchesAndRouters-page">
      <Helmet>
        <title>Industrial Switches and Routers - Dealer Distributor in Pune, Mumbai, Maharashtra, Vadodara, Surat, Ahmedabad, Gujarat, Indore, MP, Jaipur, Rajasthan, Noida, Gurugram, Delhi, Kolkata, West Bengal, Bhubaneswar, Orissa, Hyderabad, Telangana, Vishakhapatnam, AP, Chennai, Coimbatore, TN, Bengaluru, Karnataka, India</title>
        <meta name="description" content="Calid Technologies offers innovative enterprise solutions and factory digital transformations." />
        <meta name="keywords" content="Calid Technologies, enterprise solutions, factory digital transformations, digital technology, innovation" />
        <meta
          name="description"
          content="Calid Technologies offers innovative enterprise solutions and factory digital transformations."
        />
        <meta
          name="keywords"
          content="Calid Technologies, enterprise solutions, factory digital transformations, digital technology, innovation"
        />
        <meta name="author" content="Calid Technologies" />
        <meta name="robots" content="index, follow" />

        {/* Dealer Tags */}
        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Pune"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Pune"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Pune"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Mumbai"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Mumbai"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Mumbai"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Maharashtra"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Maharashtra"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Maharashtra"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Vadodara"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Vadodara"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Vadodara"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Surat"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Surat"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Surat"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Ahmedabad"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Ahmedabad"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Ahmedabad"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Indore"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Indore"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Indore"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Jaipur"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Jaipur"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Jaipur"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Noida"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Noida"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Noida"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Gurugram"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Gurugram"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Gurugram"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Delhi"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Delhi"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Delhi"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Kolkata"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Kolkata"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Kolkata"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Bhubaneswar"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Bhubaneswar"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Bhubaneswar"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Hyderabad"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Hyderabad"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Hyderabad"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Visakhapatnam"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Visakhapatnam"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Visakhapatnam"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Chennai"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Chennai"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Chennai"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Coimbatore"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Coimbatore"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Coimbatore"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Bengaluru"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Bengaluru"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Bengaluru"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Tamil Nadu"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Tamil Nadu"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Tamil Nadu"
        />

        <meta
          name="keywords"
          content="Industrial Switches And Routers Dealer in Karnataka"
        />
        <meta
          name="keywords"
          content="Best Industrial Switches And Routers Dealer in Karnataka"
        />
        <meta
          name="keywords"
          content="Industrial Switches And Routers Distributor in Karnataka"
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Calid Technologies" />
        <meta
          property="og:description"
          content="Calid Technologies offers innovative enterprise solutions and factory digital transformations."
        />
        <meta
          property="og:image"
          content="https://calidtech.com/og-image.jpg"
        />
        <meta property="og:url" content="https://calidtech.com" />
        <meta property="og:site_name" content="Calid Technologies" />
        <meta property="fb:app_id" content="Your Facebook App ID" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tata Communication Case Study" />
        <meta
          name="twitter:description"
          content="Discover how Calid Technologies delivers advanced Smart Energy Meters for Automatic Meter Reading (AMR). Our solutions streamline energy management and improve accuracy for efficient and reliable utility monitoring."
        />
        <meta name="twitter:image" content="URL to your image" />
        <meta name="twitter:site" content="@YourTwitterHandle" />
        <meta name="twitter:creator" content="@YourTwitterHandle" />
        <meta itemprop="name" content="Calid Technologies" />
        <meta
          itemprop="description"
          content="Calid Technologies offers innovative enterprise solutions and factory digital transformations."
        />
        <meta
          itemprop="image"
          content="https://www.calidtech.com/static/media/logo_bgremove.2c4802e6a4a1a143d254.png"
        />

        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="apple-mobile-web-app-title" content="Calid Technologies" />
        <meta name="application-name" content="Calid Technologies" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
          name="msapplication-TileImage"
          content="https://www.calidtech.com/static/media/logo_bgremove.2c4802e6a4a1a143d254.png"
        />
        <meta name="theme-color" content="#ffffff" />

        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.json" />
        <link
          rel="canonical"
          href="https://calidtech.com/ManufacturingIndustrialSwitchesAndRoutersSubcategoryPage"
        />
      </Helmet>

      <ManufacturingHeader />
      <ManufacturingCategoryPageNavBar />
      <div className="manufacturing-small-heder-navbar">
        {/* {subproductNames[currentSubproduct]} */}
        Communication And Computing - Industrial Switches And Routers
      </div>
      <div className="industrialSwitchesAndRouters-subproduct-nav">
        <button
          className={`industrialSwitchesAndRouters-subproduct-nav-button ${currentSubproduct === 1
            ? "active-industrialSwitchesAndRouters-subproduct"
            : ""
            }`}
          onClick={() => switchSubproduct(1)}
        >
          Teltonika
        </button>
        <button
          className={`industrialSwitchesAndRouters-subproduct-nav-button ${currentSubproduct === 2
            ? "active-industrialSwitchesAndRouters-subproduct"
            : ""
            }`}
          onClick={() => switchSubproduct(2)}
        >
          Moxa
        </button>
        <button
          className={`industrialSwitchesAndRouters-subproduct-nav-button ${currentSubproduct === 3
            ? "active-industrialSwitchesAndRouters-subproduct"
            : ""
            }`}
          onClick={() => switchSubproduct(3)}
        >
          Advantech
        </button>
      </div>

      {currentProducts.map((productData, index) => (
        <ManufacturingProductComponent key={index} {...productData} share={<ShareButton id={productData.id} />} />
      ))}
      <div className="pagination">
        {getProductList().length > productsPerPage && (
          <ul className="industrialSwitchesAndRouters-ul">
            {Array(Math.ceil(getProductList().length / productsPerPage))
              .fill()
              .map((_, i) => (
                <li
                  id="-industrialSwitchesAndRouters-li"
                  key={i}
                  className={
                    currentPage === i + 1
                      ? "active-industrialSwitchesAndRouters"
                      : ""
                  }
                >
                  <button
                    className="industrialSwitchesAndRouters-button"
                    onClick={() => paginate(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
          </ul>
        )}
      </div>
      {/* <ContactUsBot /> */}
      <CallMePopup />
      <ShowMoreIcons />
      {/* <Whatsapp /> */}

      {/* <ContactButtons /> */}

      <SwitchtoEnterprise />
      <ManufacturingFooter />
    </div>
  );
};

export default ManufacturingIndustrialSwitchesAndRoutersSubcategoryPage;
